import { QueryClientProvider } from '@tanstack/react-query'
import { type PropsWithChildren } from 'react'

import { APIQueryClient } from '~sharedConfig'

export const TanstackQueryController = ({ children }: PropsWithChildren) => (
	<QueryClientProvider client={APIQueryClient}>{children}</QueryClientProvider>
)
